/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-trailing-spaces */
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  WE_ON_CALL,
  VIBER,
  TELEGRAM,
  CONSULT_HOURS_DESC,
  SUPPORT_HOURS,
} from '../../Utils/Constants/GlobalConstants';
import './css/ContactModal.css';
import Viber from '../../images/viber.png';
import Telegram from '../../images/telegram.png';
import { changeContactModalVisible } from '../../DataStore/actions/searchFormActions';
import { ReactComponent as Close } from '../../images/close-r.svg';

const mapStateToProps = (state) => ({ ...state });

class ContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { scrollbarWidth: 0 };
  }

  componentDidMount() {
    const scrollWidth =
      window.innerWidth - document.documentElement.clientWidth;
    this.setState({ scrollbarWidth: scrollWidth });
  }

  close = () => {
    const { changeContactModalVisible: changeContactModalVisibleAction } =
      this.props;

    changeContactModalVisibleAction(false);

    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  handleOutCLick = (e) => {
    const className = e.target.className;
    if (
      !this.node.contains(e.target) ||
      className === 'messangerItem' ||
      className === 'bm_text_18' ||
      className === 'messIco'
    ) {
      this.close();
    }
  };

  render() {
    const { scrollbarWidth } = this.state;
    const { contactModalVisible } = this.props;

    if (!contactModalVisible) {
      return null;
    }

    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    return (
      <>
        {contactModalVisible && (
          <div className="modalContainer" onClick={this.handleOutCLick}>
            <div className="modalContentWrapp">
              <div
                className="modalContent"
                ref={(node) => {
                  this.node = node;
                }}
              >
                <div className="modalTitleLine">
                  <div className="modalTitle bm_text_24">{WE_ON_CALL}</div>
                </div>
                <button
                  type="button"
                  className="messClose"
                  onClick={this.close}
                >
                  <Close />
                </button>

                <div className="itemsWrappW mb_20">
                  <div className="itemsWrapp">
                    <Link
                      target="_blank"
                      to="https://t.me/tourhunter_by"
                      className="messangerItem"
                    >
                      <img src={Telegram} alt="" className="messIco" />
                      <div className="bm_text_18">{TELEGRAM}</div>
                    </Link>

                    <Link
                      target="_blank"
                      to="viber://chat?number=%2B375296659965"
                      className="messangerItem"
                    >
                      <img src={Viber} alt="" className="messIco" />
                      <div className="bm_text_18">{VIBER}</div>
                    </Link>
                  </div>
                </div>
                <div className="gr_text_14 mb_4 modalContactHours">
                  {CONSULT_HOURS_DESC}
                </div>
                <div className="gr_text_14 modalContactHours">
                  {SUPPORT_HOURS}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

ContactModal.propTypes = {
  contactModalVisible: PropTypes.bool.isRequired,
  changeContactModalVisible: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  changeContactModalVisible,
})(ContactModal);
